//TODO: Pagination for students list - On Hold
//TODO: Pagination for students list in modal - On Hold
//TODO: Add attendance to student page (View) - Done
//TODO: Add attendance to course (View by student) - Done
//TODO: Automatically add group requests - Done
//TODO: The issue with options in the course - In Progress

//2025-09-22
//TODO: 1. Подсвечивать группу красным если она не выбрано в модальном окне добавления в курс - Done
//TODO: 2. Дискаунт для компаний в процентах / доп окно с комментарием
//TODO: 3. Если студента удалили из курса он не появляется в курсе - In Progress
//TODO: 4. Когда удаляют студента ставить дату удаления на группу (таблицу связей)
//TODO: 5. Поле аллергия - расширить - Done
//TODO: 6. Оплата писать время и аккаунт - In progress
//TODO: 7. !!! Объединить дубликаты опций в курсах, при удалении опции сделать перенос студента в группу Requests

//TODO: Проверять имя/номер телефона/ дату рождения - повторная регистрация на другой курс или время
//TODO: Оставить опцию Trial но ставить признак в профиле студента о визите пробного занятия
//TODO: Букирование - добавить дату для ивента
//TODO: Учителям открыть посещаемость -Done
//TODO: Срабатывание поиска по нажатию Enter - Done


(()=> {
    'use strict'

    let mobile = 0;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) mobile = 1;

    if (mobile === 1) {
        let elem = document.querySelector('body'),
            header = document.querySelector('.bottom-bar'),
            heightHeader = header.offsetHeight / 2,
            lastScrollTop = 0;

        document.addEventListener('scroll', () => {
            let scrollY = window.scrollY;

            (scrollY > window.innerHeight / 10 ? elem.classList.add('menu-up') : elem.classList.remove('menu-up'));
            (scrollY > heightHeader ? elem.classList.add('menu-down') : elem.classList.remove('menu-down'));
            (scrollY < lastScrollTop ? elem.classList.remove('menu-up') : null);
            lastScrollTop = scrollY;
        });
    }
//GENERAL----------------------------------------------------------------------------------------------------------------
    window.postData = async (url= '', data = {}) => {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: Object.entries(data).map(([k,v])=>{return k+'='+v}).join('&')
        });
        return await response.json();
    }

    const btnBack = document.querySelector('.btn-back');
    if (btnBack) {
        btnBack.addEventListener('click', (e) => {
            e.preventDefault();
            if (document.referrer) {
                window.location.href = document.referrer;
            }
        });
    }

    // Global Preloader Functions
    window.addPreloader = (targetElement) => {
        const preloader = document.createElement('div');
        preloader.classList.add('preloader', 'position-absolute', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2');
        preloader.style.cssText = `left: 1rem; right: 1rem; top: 1rem; bottom: 1rem; background: rgba(255,255,255, 0.5);`;
        preloader.innerHTML = `<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>`;
        targetElement.appendChild(preloader);
        return preloader; // Return the preloader element for later removal
    };
    
    window.removePreloader = (preloader) => {
        if (preloader && preloader.parentNode) {
            preloader.remove();
        }
    };

    //Global Toast Function
    window.showToast = (message, type = '', duration = 5000) => {
        const toastContainer = document.querySelector('.toast-container') || createToastContainer();
        const toastId = `toast-${Date.now()}`;
        const toastHTML = `
            <div id="${toastId}" class="toast align-items-center rounded-3 text-white text-bg-${type}" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="d-flex">
                    <div class="toast-body pt-3 ps-3">
                        ${message}
                    </div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>
        `;
        toastContainer.innerHTML += toastHTML;
    
        const toastElement = document.getElementById(toastId);
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastElement, { delay: duration });
        toastBootstrap.show();
    
        toastElement.addEventListener('hidden.bs.toast', () => {
            toastElement.remove();
        });
    };
//----------------------------------------------------------------------------------------------------------------------

//NAVBAR----------------------------------------------------------------------------------------------------------------
    const myOffcanvas = document.querySelector('.sidebar')
    myOffcanvas.addEventListener('hide.bs.offcanvas', () => {
        let elem = document.querySelector('.nav-icon-5');
        elem.classList.toggle('open');
    });
    myOffcanvas.addEventListener('show.bs.offcanvas', () => {
        let elem = document.querySelector('.nav-icon-5');
        elem.classList.toggle('open');
    });
//----------------------------------------------------------------------------------------------------------------------

//frchs Select----------------------------------------------------------------------------------------------------------
    const frchsSelect = document.querySelector('#frchsSelect');
    if (frchsSelect) {
        frchsSelect.addEventListener('change', (e) => {
            let selectedValue = e.target.value;
            postData('', {fid:selectedValue, event:'frchsChange'}).then(data => {
                window.location.reload();
            });
        })
    }
//----------------------------------------------------------------------------------------------------------------------

//PAYMENTS--------------------------------------------------------------------------------------------------------------
    //Payment modal-----------------------------------------------------------------------------------------------------
    const paymentAction = () => {
        const addPayment = document.querySelectorAll('.add-payment');

        addPayment.forEach((elem) => {
            elem.onclick = () => {
                document.querySelector('#addPayment input[name="sid"]').value = elem.parentNode.dataset.sid;
                document.querySelector('#addPayment .modal-title').innerHTML = 'Add a payment for ' + elem.parentNode.dataset.stuname;
            }
        });
    }
    //Payments list-----------------------------------------------------------------------------------------------------
    window.paymentsList = (balanceRefresh = false) => {
        const urlParams = new URLSearchParams(window.location.search);
        let pages = 1,
            page = urlParams.get('page'),
            tbody = document.querySelector('#stu-pay tbody');

        let preloader = document.createElement('div');
        preloader.classList.add('payments-preloader', 'd-flex', 'align-items-center', 'justify-content-center');
        preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
        tbody.parentNode.parentNode.appendChild(preloader);

        if (!page) {
            urlParams.set('page', 1);
            page = 1;
        }

        postData('', {sid: urlParams.get('sid'), page: page, event: 'payments'}).then(data => {
            let count = data[0]['count'];

            if (count > 0) {
                pages = Math.ceil(count / 5);
                if (pages > 1) {
                    let pagination = document.getElementById('pagination');
                    pagination.style.display = 'block';
                    urlParams.set('from', pages);
                    history.pushState(null, '', `profile.html?${urlParams}`);
                }
                tbody.innerHTML = '';
                data[1].forEach((row) => {
                    let elem = document.createElement('tr');
                    let date = new Date(row['date'] * 1000);
                    date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                    elem.id = row.id;
                    elem.innerHTML = `
                    <td>${date}</td>
                    <td class="${row.type == 'debit' ? 'text-danger' : 'text-success'}">${row.currency == 1 ? '&euro;' : row.code} ${row.amount}</td>
                    <td class="text-capitalize">${row.type}</td>
                    <td class="${row.balance > 0 ? 'text-success' : 'text-danger'}">${row.currency == 1 ? '&euro;' : row.code} ${row.balance}</td>
                    <td>${row.comment}</td>
                `;
                    tbody.appendChild(elem);
                });
                if (balanceRefresh) {
                    document.getElementById('stu-balance').innerHTML = data[1][0]['balance'];
                }
            } else {
                let elem = document.createElement('tr');
                elem.innerHTML = '<tr><td colSpan="5">There are no transactions yet</td></tr>';
                tbody.appendChild(elem);
            }
            preloader.remove();
        });
    }

    //Payment list pagination-------------------------------------------------------------------------------------------
    const payPag = document.querySelectorAll('#pagination .page-link');
    payPag.forEach((elem) => {
        elem.onclick = (e) => {
            e.preventDefault();

            const urlParams = new URLSearchParams(window.location.search);
            let page = urlParams.get('page'),
                act = elem.dataset.act,
                pages = urlParams.get('from');

            if (pages > 1) {
                if (act === 'next' && page < pages) {
                    page = Number(page) + 1;
                }

                if (act === 'prev' && page > 1) {
                    page = Number(page) - 1;
                }

                if (page >= 1) {
                    urlParams.set('page', page);
                    history.pushState(null, '', `profile.html?${urlParams}`);
                    paymentsList();
                }
            }
        }
    });

    //Modal btn click
    const submit_buttons = document.querySelectorAll('.submit');
    Array.from(submit_buttons).forEach(submit_button => {
        submit_button.addEventListener('click', event => {
            const domEvent = document.createEvent('Event');
            domEvent.initEvent('submit', false, true);
            event.target.parentNode.parentNode.querySelector('form').dispatchEvent(domEvent);
        });
    });
//----------------------------------------------------------------------------------------------------------------------

//STUDENT COURSES-------------------------------------------------------------------------------------------------------
    window.coursesList = () => {
        const urlParams = new URLSearchParams(window.location.search),
              sid = urlParams.get('sid'),
              viewer = document.querySelector('body').dataset.viewer;
        let tbody = document.querySelector('#stu-courses tbody');
        let preloader = document.createElement('div');
        preloader.classList.add('payments-preloader', 'd-flex', 'align-items-center', 'justify-content-center');
        preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
        tbody.parentNode.parentNode.appendChild(preloader);

        postData('', {sid: sid, event: 'courses'}).then(data => {
            tbody.innerHTML = '';
            data.forEach((row) => {
                let elem = document.createElement('tr');
                elem.id = row.id;
                elem.innerHTML = `<td>${row.name}</td>`;

                if (row.options) {
                    let options = JSON.parse(row.options);
                    options.forEach((option) => {
                        if (row.oid === option.id) {
                            row.options = option;
                            elem.innerHTML += `
                                <td class="d-none d-md-table-cell">
                                    <b>Group</b>: ${row.comment}
                                    <br><b>Pack. name</b>: ${row.options.des}
                                    <br><b>Price</b>: ${row.options.price}
                                    <br><b>Sessions</b>: ${row.options.qty}
                                </td>
                            `;
                        }
                    });
                } else {
                    elem.innerHTML += `<td class="d-none d-md-table-cell"> &mdash; </td>`;
                }

                elem.innerHTML += `
                    <td>
                        <a href="courses/course.html?cid=${row.id}&gid=${row.gid}&act=view" class="btn btn-brand-secondary btn-sm mb-2" title="View">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 576 512">
                                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
                            </svg>
                        </a>
                        ${viewer !== '4' ? `
                        <button class="btn btn-success btn-sm mb-2 change-course" title="Change" data-bs-toggle="modal" data-bs-target="#addToCourse">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 640 640"><path d="M535.6 85.7C513.7 63.8 478.3 63.8 456.4 85.7L432 110.1L529.9 208L554.3 183.6C576.2 161.7 576.2 126.3 554.3 104.4L535.6 85.7zM236.4 305.7C230.3 311.8 225.6 319.3 222.9 327.6L193.3 416.4C190.4 425 192.7 434.5 199.1 441C205.5 447.5 215 449.7 223.7 446.8L312.5 417.2C320.7 414.5 328.2 409.8 334.4 403.7L496 241.9L398.1 144L236.4 305.7zM160 128C107 128 64 171 64 224L64 480C64 533 107 576 160 576L416 576C469 576 512 533 512 480L512 384C512 366.3 497.7 352 480 352C462.3 352 448 366.3 448 384L448 480C448 497.7 433.7 512 416 512L160 512C142.3 512 128 497.7 128 480L128 224C128 206.3 142.3 192 160 192L256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128L160 128z"/></svg>
                            <span class="position-relative w-100 h-100 d-block"></span>
                        </button>
                        <button class="btn btn-danger btn-sm mb-2 del-from-group" title="Remove" data-gid="${row.gid}" data-sid="${sid}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"></path></svg>
                            <span class="position-relative w-100 h-100 d-block"></span>
                        </button>` : ''}
                    </td>
                `;

                tbody.appendChild(elem);
            });
            preloader.remove();
        });
    }
//----------------------------------------------------------------------------------------------------------------------

//INPUT-FOCUS-----------------------------------------------------------------------------------------------------------
    const cForm = document.querySelectorAll('.modal form input, .modal form textarea')
    if (cForm) {
        cForm.forEach((elem) => {
            elem.onclick = () => {
                elem.addEventListener('focusout', (event) => {
                    (event.target.value !== '' ? event.target.classList.add('focus') : event.target.classList.remove('focus'));
                });
            }
        });
    }

//FORM SENDING AND CLEAR------------------------------------------------------------------------------------------------
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.submit-form')

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                form.classList.add('was-validated');
            } else {
                let loading = document.createElement('div');
                loading.classList.add('loading', 'd-flex', 'justify-content-center', 'align-items-center');
                loading.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>';
                form.parentNode.appendChild(loading);
                sendForm(form);
                event.preventDefault();
            }
        }, false)
    });

    //Send form
    const sendForm = (form) => {
        let response,
            formData = new FormData(form),
            xhr = new XMLHttpRequest(),
            url = form.action;

        xhr.open('POST', url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onload = () => {
            if (xhr.status === 200) {
                response = JSON.parse(xhr.response);
                if (response[0] === 'success') {
                    if (form.dataset.modal) {
                        let elem = form.parentNode.parentNode.parentNode.parentNode,
                            myModal = bootstrap.Modal.getOrCreateInstance(elem);
                        myModal.hide();
                    }

                    if (form.dataset.name === 'add_stu') {
                        stuRowAdd(response[2], formData.get('name') + ' ' + formData.get('surname'), formData.get('cur_code'));
                    }

                    if (form.dataset.name === 'payments') {
                        let sid = form.querySelector('input[name="sid"]').value,
                            elem = document.getElementById('stu-list');
                        if (elem) {
                                let row = document.getElementById(sid),
                                    b_elem = row.querySelector('.balance');

                            b_elem.innerHTML = response[2];

                            b_elem.parentNode.classList.add('text-bg-warning');
                            if (response[2] > 0) {
                                b_elem.parentNode.classList.remove('text-danger', 'text-body');
                                b_elem.parentNode.classList.add('text-success')
                            } else {
                                b_elem.parentNode.classList.remove('text-danger', 'text-body');
                                b_elem.parentNode.classList.add('text-success');
                            }
                            setTimeout(() => {
                                b_elem.parentNode.classList.remove('text-bg-warning');
                            }, 1000);
                        } else {
                            elem = document.getElementById('stu-pay');
                            //let row = document.createElement('tr');
                            const urlParams = new URLSearchParams(window.location.search);
                            urlParams.set('page', 1);
                            history.pushState(null, '', `profile.html?${urlParams}`);
                            paymentsList(true);
                        }
                    }

                    document.querySelector('.toast-container').innerHTML += `
                        <div id="liveToast" class="toast align-items-center rounded-3 text-white" role="alert" aria-live="assertive" aria-atomic="true">
                            <div class="d-flex">
                                <div class="toast-body pt-3 ps-3">
                                    ${response[1]}
                                </div>
                                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                            </div>
                        </div>
                    `;
                    const toastLive = document.getElementById('liveToast')
                    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
                    toastBootstrap.show();
                    toastLive.addEventListener('hidden.bs.toast', () => {
                        toastLive.remove();
                    });

                    document.querySelector('.loading').remove();
                } else {
                    alert('Request failed');
                    console.log('Request failed/Code 113');
                }
            } else {
                alert('Request failed');
                console.log('Request failed/Code 112');
            }
        }
        xhr.send(formData);
    }

    //Clear form when modal closed
    const modals = document.querySelectorAll('.modal');
    Array.from(modals).forEach(modal => {
        modal.addEventListener('hidden.bs.modal', event => {
            let form = modal.querySelector('form');
            if (form) {  // Add null check
                const formInputs = form.querySelectorAll('input, textarea');
                if (formInputs) {
                    formInputs.forEach(elem => {
                        elem.classList.remove('focus');
                    });
                }
                form.reset();
                if (modal.querySelector('.was-validated')) form.classList.remove('was-validated');
                if (modal.querySelector('.loading')) modal.querySelector('.loading').remove();
            }
         });
    })
//----------------------------------------------------------------------------------------------------------------------

//STUDENTS LIST ACTIONS-------------------------------------------------------------------------------------------------
    const stu_list_page = document.querySelector('.stu-list');

    window.stuList = (data) => {
        // Проверка: если есть поле list и оно массив — используем его
        if (data && Array.isArray(data.list)) {
            data = data.list;
        }

        let tbody = document.querySelector('.reg-table tbody');
        let rows = tbody.querySelectorAll('tr');

        rows.forEach(row => {
            row.remove();
        });

        data.forEach((data, index) => {
            let elem = document.createElement('tr'),
                date = new Date(data.createdon * 1000),
                last_payment = data.last_payment ? new Date(data.last_payment * 1000) : '';
            elem.id = data.id;
            date = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            last_payment = last_payment ? last_payment.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '&mdash;';

            // if (data.status === 0) {
            //     class_name = Array('new-student', 'bg-warning');
            //     button = `
            //         <button class="btn btn-primary btn-sm stu-action" title="Activate" data-act="act">
            //             <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"  viewBox="0 0 640 512"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
            //             <span class="d-none d-lg-inline">Activate</span>
            //         </button>
            //     `;
            // } else {
            //     class_name = Array('active-student', 'bg-brand-primary');
            //     button = `
            //         <button class="btn btn-danger btn-sm stu-action" title="Remove" data-act="del">
            //             <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
            //             <span class="d-none d-lg-inline">Remove</span>
            //         </button>
            //     `;
            // }
            elem.innerHTML = `
                    <td style="width: 10px; padding-left: 1rem; padding-right: 0.625rem">
                        ${index + 1}                  
                    </td>
                    <td>
                        <div class="d-flex align-items-center gap-1 gap-lg-2">
                            <span class="student-status${data.status === 0 ? ' bg-warning' : ' bg-brand-primary'}"></span>
                            <a href="profile.html?sid=${data.id}">${data.name} ${data.surname}</a>
                        </div>
                    </td>
                    <td class="d-none d-md-table-cell">${date}</td>
                    <td class="${data.balance > 0 ? 'text-success' : 'text-danger'}${data.balance === 0 ? 'text-body' : ''}">${data.code === 'EUR' ? '&euro;' : data.code} <span class="balance">${data.balance}</span></td>
                    <td class="d-none d-md-table-cell">${last_payment}</td>
                    <td>
                        <div class="d-flex align-items-center gap-2 justify-content-center" data-sid="${data.id}" data-stuname="${data.name} ${data.surname}" >
                            <button class="btn btn-success btn-sm add-payment" data-bs-toggle="modal" data-bs-target="#addPayment" title="Finance">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 576 512"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg>
                                <span class="d-none d-lg-inline">Finance</span>
                            </button>
                            <a href="profile.html?sid=${data.id}" class="btn btn-brand-secondary btn-sm" title="View">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 576 512"><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                                <span class="d-none d-lg-inline">View</span>
                            </a>
                            <button class="btn btn-danger btn-sm stu-action" title="Remove" data-act="del">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                                <span class="d-none d-lg-inline">Remove</span>
                            </button>
                        </div>
                    </td>
                `;
            tbody.appendChild(elem);
        });
    }

    if (stu_list_page) {
        //User list Load
        if (document.querySelector('#stu-list')) postData('/actions/dash/stu_list.php').then((data) => {
            stuList(data['list']);
            stuRemove();
            paymentAction();
        });

        //Remove stu
        const stuRemove = () => {
            const stu_removes = document.querySelectorAll('.stu-action');
            Array.from(stu_removes).forEach(stu_remove => {
                stu_remove.addEventListener('click', event => {
                    let stu = stu_remove.parentElement.dataset.stuname,
                        sid = stu_remove.parentElement.dataset.sid,
                        act = stu_remove.dataset.act,
                        text = '';

                    (act === 'del' ? text = 'Remove a student' : text = 'Activate a student')
                    if (confirm(`${text} ${stu}?`)) {
                        postData('/actions/dash/stu_rem_stat.php', {sid:sid, action:act}).then((data) => {
                            let row = document.getElementById(sid);
                            if(data['res'] === 'success') {
                                if (act === 'del') row.remove();
                                if (act === 'act') {
                                    let elem = document.getElementById(sid);
                                    row.querySelector('.student-status').classList.remove('bg-warning');
                                    row.querySelector('.student-status').classList.add('bg-brand-primary');
                                    stu_remove.classList.remove('btn-primary');
                                    stu_remove.classList.add('btn-danger');
                                    stu_remove.title = 'Remove';
                                    stu_remove.dataset.act = 'del';
                                    stu_remove.innerHTML = '<button class="btn btn-danger btn-sm stu-action" title="Remove" data-act="del"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path></svg><span class="d-none d-lg-inline">Remove</span>';
                                }
                            }
                        });
                    }
                });
            });
        }

        window.stuRowAdd = (sid, data, cur_code) => {
            let tbody = document.querySelector('.reg-table tbody'),
                elem = document.createElement('tr');
            elem.id = sid;
            elem.classList.add('text-bg-warning');
            elem.style.transition = 'background-color 2s';
            elem.innerHTML = `
                <td class="new-student">
                    <div class="d-flex align-items-center gap-1 gap-lg-2">
                        <span class="student-status bg-warning"></span>
                        <a href="profile.html?sid=${sid}">${data}</a>
                    </div>
                </td>
                <td class="d-none d-md-table-cell">12 Nov 22</td>
                <td>${cur_code === 'EUR' ? '&euro;' : cur_code} <span class="balance">0</span></td>
                <td class="d-none d-md-table-cell"> - </td>
                <td>
                    <div class="d-flex align-items-center gap-2 justify-content-center" data-sid="${sid}" data-stuname="${elem.name} ${elem.surname}" >
                        <button class="btn btn-success btn-sm add-payment" data-bs-toggle="modal" data-bs-target="#addPayment" title="Finance">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 576 512"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg>
                            <span class="d-none d-lg-inline">Finance</span>
                        </button>
                        <a href="profile.html?sid=${sid}" class="btn btn-brand-secondary btn-sm" title="View">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 576 512"><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                            <span class="d-none d-lg-inline">View</span>
                        </a>
                        <button class="btn btn-danger btn-sm stu-action" title="Remove" data-act="del">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                            <span class="d-none d-lg-inline">Remove</span>
                        </button>
                    </div>
                </td>
            `;
            tbody.prepend(elem);
            setTimeout(() => {
                document.getElementById(sid).classList.remove('text-bg-warning');
            }, 1000);
            stuRemove();
            paymentAction();
        }

        const addon1 = document.getElementById('button-addon1');
        addon1.onclick = (e) => {
            document.getElementById('search').value = '';
            postData('/actions/dash/stu_list.php').then((data) => {
                stuList(data);
            });
        }

        const addon2 = document.getElementById('button-addon2');
        addon2.onclick = (e) => {
            let search = document.getElementById('search').value;
            postData('/actions/dash/stu_list.php', (search ? {name: search} : '')).then((data) => {
                stuList(data);
            });
        }

        // Add keypress event listener for search input
        const searchInput = document.getElementById('search');
        searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                let search = searchInput.value;
                postData('/actions/dash/stu_list.php', (search ? {name: search} : '')).then((data) => {
                    stuList(data);
                });
            }
        });

        // Add keydown event listener for ESC key
        searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                searchInput.value = '';
                postData('/actions/dash/stu_list.php').then((data) => {
                    stuList(data);
                });
            }
        });
    }
//----------------------------------------------------------------------------------------------------------------------

//CMS PAGE ACTIONS-------------------------------------------------------------------------------------------------
//     const cms_page = document.querySelector('.cms-page');
//     if (cms_page) {
//         const btnSave = document.querySelector('#btnSave');
//         btnSave.addEventListener('click', (e) => {
//             postData('/actions/dash/settings.php').then((data) => {
//                 console.log(data);
//             });
//         });
//     }
//----------------------------------------------------------------------------------------------------------------------
})();